import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
// import { LoggerService } from '../util-services/logger.service';
import { InitAuthService } from '@app/services/global-services/auth/init-auth-service';

/*@Injectable({
  providedIn: 'root',
})
export class IsAnonymousGuard  {
  constructor(
    private initAuthService: InitAuthService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    // LoggerService.log('Inside IsAnonymousGuard');
    return this.initAuthService.isAuthenticated().pipe(
      switchMap((isAuthenticated: boolean) => {
        // LoggerService.log(
        //   'Inside IsAnonymousGuard isAuthenticated ',
        //   isAuthenticated
        // );
        if (isAuthenticated) {
          this.router.navigateByUrl('/').then();
          return of(false);
        } else {
          // LoggerService.log('Load Login Screen');
          return of(true);
        }
      })
    );
  }
}*/

export const IsAnonymousGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const initAuthService: InitAuthService = inject(InitAuthService);

  const router: Router = inject(Router);

  return initAuthService.isAuthenticated().pipe(
    switchMap((isAuthenticated: boolean) => {
      // LoggerService.log(
      //   'Inside IsAnonymousGuard isAuthenticated ',
      //   isAuthenticated
      // );
      if (isAuthenticated) {
        router.navigateByUrl('/').then();
        return of(false);
      } else {
        // LoggerService.log('Load Login Screen');
        return of(true);
      }
    })
  );
};
